// ============================================================
// UrbanWear — App.tsx (React Router v6, React 18)
// ============================================================
import { Routes, Route } from 'react-router-dom'
import { Suspense, lazy } from 'react'
import Layout from '@/components/layout/Layout'
import AdminLayout from '@/components/layout/AdminLayout'
import LoadingScreen from '@/components/shared/LoadingScreen'

const HomePage       = lazy(() => import('@/pages/home/HomePage'))
const CatalogPage    = lazy(() => import('@/pages/catalog/CatalogPage'))
const ProductPage    = lazy(() => import('@/pages/product/ProductPage'))
const CartPage       = lazy(() => import('@/pages/cart/CartPage'))
const CheckoutPage   = lazy(() => import('@/pages/checkout/CheckoutPage'))
const OrderSuccess   = lazy(() => import('@/pages/checkout/OrderSuccess'))
const AccountPage    = lazy(() => import('@/pages/account/AccountPage'))
const LoginPage      = lazy(() => import('@/pages/auth/LoginPage'))
const RegisterPage   = lazy(() => import('@/pages/auth/RegisterPage'))
const TwoFactorPage  = lazy(() => import('@/pages/auth/TwoFactorPage'))
const AdminDashboard = lazy(() => import('@/pages/admin/DashboardPage'))
const AdminSecurity  = lazy(() => import('@/pages/admin/SecurityPage'))
const AdminPayments  = lazy(() => import('@/pages/admin/PaymentsPage'))
const AdminSiteConfig = lazy(() => import('@/pages/admin/SiteConfigPage'))
const AdminProducts  = lazy(() => import('@/pages/admin/ProductsPage'))
const AdminOrders    = lazy(() => import('@/pages/admin/OrdersPage'))
const AdminInventory = lazy(() => import('@/pages/admin/InventoryPage'))
const NotFound       = lazy(() => import('@/pages/NotFound'))
const AdminUsers = lazy(() => import('@/pages/admin/UsersPage'))
const AdminReports = lazy(() => import('@/pages/admin/ReportsPage'))
const TrackOrder = lazy(() => import('@/pages/orders/TrackOrderPage'))
const AdminImport = lazy(() => import('@/pages/admin/ImportPage'))

export default function App() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        {/* Tienda pública */}
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="hombre"      element={<CatalogPage gender="hombre" />} />
          <Route path="mujer"       element={<CatalogPage gender="mujer" />} />
          <Route path="colecciones" element={<CatalogPage />} />
		   <Route path="rastrear" element={<TrackOrder />} />
          <Route path="mayoreo"     element={<CatalogPage orderType="wholesale" />} />
          <Route path="outlet"      element={<CatalogPage onSale={true} />} />
          <Route path="productos/:slug" element={<ProductPage />} />
          <Route path="carrito"     element={<CartPage />} />
          <Route path="checkout"    element={<CheckoutPage />} />
          <Route path="pedido/confirmado/:orderId" element={<OrderSuccess />} />
          <Route path="mi-cuenta"   element={<AccountPage />} />
		  <Route path="contenido" element={<AdminSiteConfig />} />
        </Route>

        {/* Auth */}
        <Route path="/login"      element={<LoginPage />} />
        <Route path="/login/2fa"  element={<TwoFactorPage />} />
        <Route path="/registro" element={<RegisterPage />} />

        {/* Admin */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index             element={<AdminDashboard />} />
          <Route path="productos"  element={<AdminProducts />} />
          <Route path="pedidos"    element={<AdminOrders />} />
          <Route path="inventario" element={<AdminInventory />} />
          <Route path="pagos" element={<AdminPayments />} />
		  <Route path="contenido" element={<AdminSiteConfig />} />
		  <Route path="seguridad"  element={<AdminSecurity />} />
		  <Route path="usuarios" element={<AdminUsers />} />
		  <Route path="reportes" element={<AdminReports />} />
		  <Route path="importar" element={<AdminImport />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  )
}
